/**
 * @desc 监测点选框
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamCheckBoxResponse>>> {
  return defHttp.get({
    url: '/web/EPManage/getMonitoringPoint',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamCheckBoxResponse>>> {
  return defHttp.get({
    url: '/mock/web/EPManage/getMonitoringPoint',
  });
}
